import React from 'react';
import PropTypes from "prop-types";
import FieldGroup from "../FieldGroup";

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: "",
            debounce: null
        }
    };

    queryChanged(e) {
        if (this.state.debounce) {
            clearTimeout(this.state.debounce);
        }

        this.setState({
            query: e.target.value, debounce: setTimeout(function () {
                this.props.onChange(this.state.query);
                this.setState({debounce: null})
            }.bind(this), 300)
        });
    }

    render() {
        return (
            <FieldGroup
                value={this.state.query}
                type="text"
                onChange={e => this.queryChanged(e)}
                placeholder="Search..."
            />
        );
    };
}

SearchBar.propTypes = {
    onChange: PropTypes.func.isRequired
};

export default SearchBar;


// WEBPACK FOOTER //
// ./src/components/languages/SearchBar.js